import { IPieChartDataSet } from '../../Component/Common/Components/Charts/Base/PieChart/IPieChartData';
import { removeWhiteSpaceChars } from '../../Component/Model/helpers';

export const columnSegmentColumnChart = (labels: Array<string | Array<string>>, onSegmentClick?: (label: string) => void, chartData?: any) =>
    ({ chartWrapper }: any) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();

        if (selection.length === 1) {
            const [selectedItem] = selection;
            const { row } = selectedItem;

            var labelData = labels[row];
            var finalLabel = '';

            if (chartData) {
                if (row == null) {
                    finalLabel = chartData[0][selectedItem.column];
                } else {
                    let originalLabel;
                    finalLabel = findOriginalLabel(chartData[selectedItem.row + 1]) + '|' + chartData[0][selectedItem.column];
                }
            }
            else if (labelData) {
                for (var i = 0; i < labelData.length; i++) {
                    finalLabel = finalLabel + labelData[i];
                }
            }

            finalLabel = removeWhiteSpaceChars(finalLabel);
            if (onSegmentClick) onSegmentClick(finalLabel);
        }
    }

const findOriginalLabel = (data: any): string | null => {

    if (Array.isArray(data)) {
        for (let index = 0; index < data.length; index++) {
            if (data[index] && data[index].hasOwnProperty('originalLabel'))
                return data[index].originalLabel;
        }
    }
    return data[0];
}

export const pieSegmentColumnChart = (data: Array<IPieChartDataSet>, onSegmentClick?: (label: string) => void) =>
    ({ chartWrapper }: any) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        if (selection.length === 1) {
            const [selectedItem] = selection;
            const { row } = selectedItem;
            var itemData = data[row];
            var finalLabel = removeWhiteSpaceChars(itemData.label);
            if (onSegmentClick) onSegmentClick(finalLabel);
        }
    }